import React from "react";
import "styled-components/macro";
import { SimpleTextarea } from "../forms-stuff/simple-textarea";

const HELPER_TEXT =
  "Help us understand the nature of your student outreach and how the student is feeling about LSS";

export function NotesInput({
  value,
  onValueChange,
  activeField,
  setActiveField,
  height = "100px",
  helperText = HELPER_TEXT,
}) {
  return (
    <SimpleTextarea
      text={value}
      setText={onValueChange}
      fieldLabel={"Notes"}
      fieldHelperText={helperText}
      fieldId={"notes"}
      activeFieldId={activeField}
      setActiveFieldId={setActiveField}
      height={height}
      icon="comment"
    />
  );
}
